import {Component} from "@angular/core";
import {Router} from "@angular/router";
import {
    AuthService,
    ConfigurationService,
    DataClientError,
    LoginType,
    provideEntityModel
} from "@fedeltapointofsale/data-client";
import {ErrorHandlerService} from "../../error-handler.service";
import {FUIAlertService} from "@fedeltapointofsale/ui";
import {UserProfileSummaryEntityModel} from "../user-profile-summary-entity.model";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {BehaviorSubject} from "rxjs";
import {Local} from "../../config";
import {HttpClient} from "@angular/common/http";

export class UserDetails {
    firstName: string;
    lastName: string;
    userName: string;
    email: string;
    password: string;
}

@Component({
    selector: "wbo-user-profile-setup-page",
    templateUrl: "./user-profile-setup-page.component.html",
    styleUrls: ["./user-profile-setup-page.component.scss"],
    providers: [provideEntityModel(UserProfileSummaryEntityModel)]
})
export class UserProfileSetupPageComponent {
    formGroup: FormGroup;

    user: UserDetails = new UserDetails();
    remember: boolean;

    constructor(private router: Router,
                private authService: AuthService,
                private configService: ConfigurationService,
                private alertService: FUIAlertService,
                private errorHandlerService: ErrorHandlerService,
                private formBuilder: FormBuilder,
                private httpClient: HttpClient) {
        this.formGroup = this.formBuilder.group({
            email: ["", [Validators.required, Validators.email, Validators.maxLength(60)]],
            userName: ["", [Validators.required, Validators.maxLength(12), Validators.minLength(4)]],
            firstName: ["", [Validators.required, Validators.maxLength(30)]],
            lastName: ["", [Validators.required, Validators.maxLength(30)]],
            password: ["", [Validators.required, Validators.maxLength(20), Validators.minLength(8)]]

        });
        this.formGroup.get("email")["required$"] = new BehaviorSubject(true);
        this.formGroup.get("userName")["required$"] = new BehaviorSubject(true);
        this.formGroup.get("firstName")["required$"] = new BehaviorSubject(true);
        this.formGroup.get("lastName")["required$"] = new BehaviorSubject(true);
        this.formGroup.get("password")["required$"] = new BehaviorSubject(true);
    }

    async proceed(): Promise<void> {
        Object.keys((this.formGroup.controls)).forEach((key) => {
            this.formGroup.controls[key].markAsTouched();
            this.formGroup.controls[key].updateValueAndValidity();
        });
        if (this.formGroup.valid) {
            if (this.user.email.indexOf("@chewzie.me") >= 0 || this.user.email.indexOf("@fedeltapos.com") >= 0) {
                this.alertService.showError(undefined, "wbo.user-profile-setup.message.onlyCustomers").subscribe(() => {
                });
                return;
            }

            this.httpClient.post((await this.configService.getString(Local.DATASERVER_URL) || "") + "/webapi/initial-setup", this.user).subscribe({
                next: () => {
                    this.authService.login(this.user.userName, this.user.password, LoginType.USER, {remember: this.remember === true})
                        .subscribe({
                            next: (success: boolean) => {
                                if (success) {
                                    this.configService.setContext("userId", this.authService.getLoggedInUserId().toString());
                                    this.configService.setContext("role", this.authService.getLoggedInRole());
                                    this.router.navigate([""]);
                                } else {
                                    this.alertService.showError(undefined, "wbo.login.error.failed").subscribe(() => {
                                        this.router.navigate([""])
                                    });
                                }
                            },
                            error: (error: DataClientError) => {
                                this.alertService.showError(undefined, "wbo.login.error.failed").subscribe(() => {
                                    this.router.navigate([""])
                                });
                            }
                        });
                },
                error: () => {
                    this.alertService.showError(undefined, "wbo.user-profile-setup.message.failedToCreateUser").subscribe(() => {
                    });
                }
            });
        } else {
            this.alertService.showError(undefined, "wbo.user-profile-setup.message.detailsRequired").subscribe(() => {
            });
        }
    }
}
